import FullAddressBuilder from '../../common/FullAddressBuilder';
import HomeActionType from '../../common/HomeActionType';

// TODO: Extract out so that it can be used in all reducers
const initialState = {
  addressAutoComplete: [],
  selectedAddressParts: {
    building: '',
    city: '',
    street: '',
    suburb: '',
    samIds: []
  },
  showLoading: false,
  partner: {
    name: '',
    leadKey: ''
  },
  error: {},
  isAddressSelected: false
};

const HomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case HomeActionType.STORE_ADDRESS_AUTO_COMPLETE:
      return Object.assign({}, state, { addressAutoComplete: action.addressAutoComplete });
    case HomeActionType.SET_LOADING_VISIBILITY:
      return Object.assign({}, state, { showLoading: action.showLoading });
    case HomeActionType.STORE_SELECTED_ADDRESS_PARTS:
      return {
        ...state,
        selectedAddressParts: action.selectedAddressParts,
        isAddressSelected: true
      };
    case HomeActionType.RESET_ADDRESS_SEARCH:
      return {
        ...initialState,
        selectedAddressParts: state.selectedAddressParts,
        isAddressSelected: false,
        partner: state.partner,
        error: {}
      };
    case HomeActionType.RESET_ALL:
      return initialState;
    case HomeActionType.STORE_PARTNER:
      return Object.assign({}, state, { partner: action.partner });
    case HomeActionType.STORE_ERROR:
      return {
        ...state,
        error: { status: action.status, message: action.message, entity: action.entity }
      };
    default:
      return state;
  }
};

export const HomeSelector = {
  getIsAddressSelected: state => state.home.isAddressSelected,
  getFullAddress: state => FullAddressBuilder.build(state.home.selectedAddressParts),
  getSelectedAddressParts: state => state.home.selectedAddressParts,
  getError: state => state.home.error,
  getAddressAutoComplete: state => state.home.addressAutoComplete,
  getIsLoading: state => state.home.showLoading
};

export default HomeReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/HomeReducer.js
 **/